<template>
  <div>
    <div class="center-box">
      <!-- 蓝色背景（移除轮播图） -->
      <div class="blue-bg">
        <div class="center-content">
          <h1 class="main-title">2026 龙门圆梦阁志愿指导系统</h1>
        </div>
      </div>

      <div class="uzy-nav-box" style="position: relative;height: 100%;">
        <div class="tianbao-box">
          <div class="title">{{showYear}}年志愿分析指导入口
            <span style="float: right;font-size: 14px;line-height: 30px;color: #888;">河北</span>
          </div>
          <div class="options">
            <div class="label">考生姓名</div>
            <el-input placeholder="请输入姓名" v-model="from.name"></el-input>
          </div>
          <div class="options" style="margin-bottom: 15px;">
            <div class="label">高考总分</div>
            <el-input type="number" placeholder="请输入内容" v-model="from.score">
              <template slot="append">分</template>
            </el-input>
          </div>
          <div class="options">
            <div class="label">选考科目</div>
            <el-checkbox-group v-model="from.kemus">
              <el-checkbox label="物理"></el-checkbox>
              <el-checkbox label="化学"></el-checkbox>
              <el-checkbox label="生物"></el-checkbox>
              <el-checkbox label="历史"></el-checkbox>
              <el-checkbox label="地理"></el-checkbox>
              <el-checkbox label="政治"></el-checkbox>
            </el-checkbox-group>
          </div>

          <div class="uzy-gaokao-date applyFor-vip1" style="display: flex;align-items: baseline;margin-top:25px;"
            @click="show">
            <div style="font-size: 20px;margin: auto;">智能填报</div>
            <div class="lighting"></div>
          </div>
        </div>
      </div>
    </div>

    <div style="background-color: #f8f8f8;padding: 10px 0;">
      <div class="uzy-nav-box" style="position: relative;height: 100%;background-color: #f8f8f8;">
        <div class="btns">
          <div class="btns-item" v-for="(item, index) of centerTabs" :key="index" style="text-align: center;">
            <el-image :src="item.src" fit="cover"></el-image>
            <div style="margin-top: 10px;">{{item.text}}</div>
          </div>
        </div>

        <div class="lines">
          <div class="line-item" v-for="(item, index) of lines" :key="index" style="text-align: center;">
            <span style="color: #e84c33;font-size: 20px;margin-right: 5px;">{{item.number}}+</span>
            <span>{{item.text}}</span>
          </div>
        </div>

      </div>
    </div>

    <el-dialog title="志愿填报" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false">
      <div style="line-height: 30px;">
        <span>考生：</span>{{from.name}}
        <span style="margin-left: 30px;">总分：</span>{{from.score}}
        <span style="margin-left: 30px;">科目：</span>{{from.kemus.join()}}
        <div style="float: right;">
          <span>年份：</span>
          <el-select v-model="showYear" placeholder="请选择" size="mini" style="width: 100px;" @change="yearChange" disabled>
            <el-option v-for="item in years" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
      </div>

      <div style="margin-top: 10px;">
        <el-input type="number" placeholder="请输入内容" v-model="from.scopeDown" size="mini"
          style="width: 180px;margin-left: 30px;">
          <template slot="prepend">下调分数</template>
        </el-input>
        <el-input type="number" placeholder="请输入内容" v-model="from.scopeUp" size="mini"
          style="width: 180px;float: left;">
          <template slot="prepend">上调分数</template>
        </el-input>
        <div style="float: right;line-height: 30px;">
          <span>分数区间：</span>{{scopeDown}} ~ {{scopeUp}}
        </div>
      </div>

      <div class="content-box" style="margin-top: 15px;">
        <div class="left">
          已<span>选</span><span>专</span>业
        </div>
        <div class="right" v-if="types.length">
          <block v-for="(item, index) of types" :key="index">
            <el-tag v-if="item1.isSel" type="warning" size="small" effect="dark" :closable="item1.isSel"
              v-for="(item1, index1) of item.filings" :key="index1" @close="changeOne(types[index], item1, false)">
              {{item1.type}}
            </el-tag>
          </block>
        </div>
      </div>

      <div class="content-box">
        <div class="left">门<span>类</span></div>
        <div class="right" v-if="types.length">
          <el-tag type="warning" size="small" :effect="type == index ? 'dark' : 'light '" v-for="(item, index) of types"
            :key="item.type" @click="type = index">{{item.type}}</el-tag>
        </div>
      </div>

      <div class="content-box" style="margin-top: 15px;border-bottom: 1px solid #e8e8e8;padding-bottom: 10px;">
        <div class="left">
          专<span>业</span>类
        </div>
        <div class="right" v-if="types.length">
          <el-tag type="warning" size="small" :effect="types[type].isSelAll ? 'dark' : 'light '"
            :closable="types[type].isSelAll" @click="allChange(types[type], true)"
            @close="allChange(types[type], false)">全部</el-tag>
          <el-tag type="warning" size="small" :effect="item.isSel ? 'dark' : 'light '" :closable="item.isSel"
            v-for="(item, index) of types[type].filings" :key="item.type" @click="changeOne(types[type], item, true)"
            @close="changeOne(types[type], item, false)">{{item.type}}</el-tag>
        </div>
      </div>

      <div class="content-box">
        <div class="left">省<span>份</span></div>
        <div class="right" v-if="address.length">
          <el-tag type="warning" size="small" :effect="item.isSel ? 'dark' : 'light '" :closable="item.isSel"
            v-for="(item, index) of address" :key="item.type" @click="changeOne1(address, item, true)"
            @close="changeOne1(address, item, false)">{{item.province}}</el-tag>
        </div>
      </div>

      <div class="uzy-gaokao-date applyFor-vip2"
        style="display: flex;align-items: baseline;margin-top: 45px;margin-bottom: 20px;" @click="submit()">
        <div style="font-size: 20px;margin: auto;">生成志愿表</div>
        <div class="lighting"></div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        from: {
          name: '',
          score: '',
          year: 2025,
          scopeUp: 15,
          scopeDown: 25,
          kemus: []
        },
        showYear: 2026,
        years:[2026],

        /* centerTabs: [{
          src: 'https://staticv2.youzy.cn/images/index/college.png',
          text: '找大学'
        }, {
          src: 'https://staticv2.youzy.cn/images/index/major.png',
          text: '查专业'
        }, {
          src: 'https://staticv2.youzy.cn/images/index/latestpcl.png',
          text: '分数线'
        }, {
          src: 'https://staticv2.youzy.cn/images/index/picixian.png',
          text: '批次线'
        }, {
          src: 'https://staticv2.youzy.cn/images/index/tiqianpi.png',
          text: '提前批'
        }, {
          src: 'https://staticv2.youzy.cn/images/index/tests.png',
          text: '学业评测'
        }, {
          src: 'https://staticv2.youzy.cn/images/index/astest.png',
          text: '录取概率'
        }, {
          src: 'https://staticv2.youzy.cn/images/index/weici.png',
          text: '位次查询'
        }, {
          src: 'https://staticv2.youzy.cn/images/index/weici.png',
          text: '高考直播'
        }], */

       /*  lines: [{
          number: 857493,
          text: '位同学在线'
        }, {
          number: 1234523,
          text: '张志愿表'
        }, {
          number: 267744,
          text: '个问题被解答'
        }, {
          number: 409,
          text: '位专家在线'
        }], */

        type: 0,
        type1: 0,
        typeAll: false,
        types: [],

        addr: 0,
        addr1: 0,
        addrAll: false,
        address: []
      }
    },
    computed: {
      scopeDown() {
        return parseInt(this.from.score) - parseInt(this.from.scopeDown)
      },
      scopeUp() {
        return parseInt(this.from.score) + parseInt(this.from.scopeUp)
      }
    },
    mounted() {
      // this.loadYear()
    },
    methods: {
      loadYear() {
        this.$api.post('filing/loadYear', {}, res => {
          this.years = res
        })
      },
      findOptions() {
        this.$api.post('filing/findOptions', {
          year: 2025,
          id: this.$parent.user.id
        }, res => {
          for (let item of res.types) {
            item.isSelAll = false
            for (let item1 of item.filings) {
              item1.isSel = false
            }
          }
          for (let item of res.address) {
            item.isSel = false
          }
          this.types = res.types
          this.address = res.address
        })
      },
      yearChange() {
        this.findOptions()
      },
      change(all, item, target) {
        if (item.isSel == target)
          return

        item.isSel = target

        let isSelAll = true
        for (let e of all.filings) {
          if (!e.isSel) {
            isSelAll = false
            break
          }
        }
        all.isSelAll = isSelAll
      },
      changeOne(all, item, target) {
        if (item.isSel == target)
          return

        item.isSel = target

        let isSelAll = true
        for (let e of all.filings) {
          if (!e.isSel) {
            isSelAll = false
            break
          }
        }
        all.isSelAll = isSelAll
      },
      changeOne1(all, item, target) {
        if (item.isSel == target)
          return

        item.isSel = target
      },
      allChange(item, target) {
        if (item.isSelAll == target)
          return

        item.isSelAll = target
        item.filings.map(e => {
          e.isSel = target
        })
      },
      show() {
        if(this.$parent.user == null){
          this.$parent.dialogVisible = true
          return
        }

        // 名称校验
        if (this.from.name == '') {
          this.$message.error('请输入考生姓名')
          return
        }

        // 分数校验
        if (this.from.score < 0 || this.from.score > 750) {
          this.$message.error('请输入正确的分数')
          return
        }

        // 科目校验
        if (this.from.kemus.length != 3) {
          this.$message.error('请选择三科科目')
          return
        }
        let kemuText = this.from.kemus.join()
        if (kemuText.indexOf("物理") == -1 && kemuText.indexOf("历史") == -1) {
          this.$message.error('必须选择 物理 或 历史 其中一科')
          return
        }
        if (kemuText.indexOf("物理") != -1 && kemuText.indexOf("历史") != -1) {
          this.$message.error('只能选择 物理 或 历史 其中一科')
          return
        }

        this.dialogVisible = true
        this.findOptions()
      },
      submit() {
        let types = []
        for (let item of this.types) {
          for (let item1 of item.filings) {
            if (item1.isSel) {
              types.push(item1.type)
            }
          }
        }
        if (types.length == 0) {
          this.$message.error('请选择专业类')
          return
        }

        let provinces = []
        for (let item of this.address) {
            if (item.isSel) {
              provinces.push(item.province)
            }
        }

        // 拼接科目
        let first = ''
        let second = []
        for (let item of this.from.kemus) {
          if (item == '物理' || item == '历史')
            first = item
          else
            second.push(item)
        }

        let param = {
          name: this.from.name,
          year: this.from.year,
          score: this.from.score,
          first: '仅' + first,
          second0: second[0],
          second1: second[1],
          types: types.join(','),
          provinces: provinces.join(','),
          scopeDown: this.scopeDown,
          scopeUp: this.scopeUp,
        }

        this.$api.post('filing/search', param, res => {
          this.$alert('符合条件共：' + res + ' 个志愿', '确定生成吗？', {
            confirmButtonText: '确定',
            callback: action => {
              if (action == 'confirm') {
                this.$api.post('filing/gen', param, res => {
                  // 跳转至我的志愿表 详情
                  this.$router.push({
                    path: 'zyb?id=' + res
                  })
                })
              }
            }
          });
        })
      }
    }
  }
</script>

<style>
  .center-box {
    background: linear-gradient(135deg, #6699CC 0%, #336699 100%);
    position: relative;
    height: 580px;
    overflow: hidden;
  }

  .blue-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 15px;
  }

  .center-content {
    text-align: center;
    color: #f8f8f8;
    z-index: 1;
  }

  .main-title {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 10px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.15);
    letter-spacing: 2px;
  }

  .sub-title {
    font-size: 16px;
    opacity: 0.9;
    letter-spacing: 4px;
  }

  .el-carousel__container {
    height: 100% !important;
  }

  .carousel-img {
    width: 100%;
    height: 100%;
  }

  .tianbao-box {
    position: absolute;
    left: 50%;
    top: 80px;
    transform: translateX(-50%);
    height: auto;
    padding: 25px 20px;
    width: 320px;
    background-color: #f8f8f8;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.12);
  }

  .title {
    margin: 30px 0 20px 0;
    font-size: 20px;
  }

  .options {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .label {
    color: #555;
    width: 100px;
  }

  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 300px;

  }

  .el-checkbox {
    margin: 3px 0 !important;
    padding: 0 5px;
    font-size: 20px;
  }

  .el-checkbox__label {
    font-size: 15px;
  }

  .el-input__inner,
  .el-input-group__append {
    border-radius: 8px;
    border: 1px solid #e0e0e0;
  }

  .el-input__inner:focus {
    border-color: #1a73e8;
    box-shadow: 0 0 0 2px rgba(26,115,232,0.1);
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #1a73e8;
    border-color: #1a73e8;
  }

  .el-checkbox__label {
    color: #333;
  }

  .el-checkbox__inner {
    width: 15px;
    height: 15px;
  }

  .btns {
    display: flex;
    justify-content: space-between;
    padding: 20px 25px 22px;
  }

  .btns-item .el-image {
    width: 50px !important;
    height: 50px !important;
  }

  .lines {
    display: flex;
    justify-content: space-between;
    padding: 12px 25px;
    border-top: 1px solid #f0f0f0;
  }

  .line-item {
    width: 25%;
    border-right: 1px solid #d7d7d7;
    font-size: 12px;
  }

  .line-item span:first-child {
    font-size: 16px !important;
  }

  .line-item:last-child {
    border-right: 0;
  }

  /* ---------------------------------------------------- */

  .el-dialog__body {
    padding: 10px 30px;
  }

  .el-input-group__prepend {
    border-radius: 0;
  }

  .content-box {
    margin-top: 20px;
    display: flex;
  }

  .content-box .left {
    width: 60px;
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
  }

  .right {
    width: 890px;
  }

  .el-tag {
    margin-right: 5px;
    margin-bottom: 8px;
    cursor: pointer;
    border-radius: 6px;
  }

  /* 志愿按钮美化 */
  .uzy-gaokao-date {
    background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%);
    color: #f8f8f8;
    border-radius: 12px;
    padding: 12px 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(26,115,232,0.3);
  }

  .uzy-gaokao-date:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(26,115,232,0.4);
  }

  /* 美化输入框聚焦效果 */
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #1a73e8;
  }
</style>



// WEBPACK FOOTER //
// src/components/first.vue